module.exports = __webpack_public_path__ + "static/media/notification.72efb1e5.svg";